import React, {
  useReducer,
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react';

import { ThemeProvider } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { useSnackbar } from 'notistack';

import imagem from '../../../assets/background.jpg';
import { getListAPI, getListAllAPI } from '../../../services';
import {
  FORNECEDOR_DEFAULT,
  formatLotes,
  formatParcelasCompra,
} from '../../../utils';
import theme from '../../DialogoEditarVenda/themes/default';
import {
  reducerCompra,
  CompraContext,
  InicioFrenteCaixaCompra,
  FinalizarFrenteCaixaCompra,
} from './Pages';

const TELA_INICIO_FRENTE_CAIXA = 0;
const TELA_FINALIZAR_FRENTE_CAIXA = 1;

const DialogoCreateCompra = forwardRef(({ handleClose }, ref) => {
  const [open, setOpen] = useState(false);
  const [tela, setTela] = useState(TELA_INICIO_FRENTE_CAIXA);
  const { enqueueSnackbar } = useSnackbar();

  const [compra, dispatch] = useReducer(reducerCompra, {
    fornecedor: null,
    lotes: [],
    parcelas: [],
    idEdit: -1,
    numeroNotaFiscal: '',
    data_faturamento: '',
    data_criacao: new Date(),
    loja: {
      nome: 'CARUARU FRIOS',
      value: 'CF',
    },
  });

  function resetar() {
    dispatch({ type: 'RESETAR_TUDO' });
  }

  async function reiniciar() {
    const dataFornecedores = await getListAllAPI(
      'fornecedores',
      ['id', 'asc'],
      { nome: FORNECEDOR_DEFAULT },
      ['cidade.estado'],
    );

    dispatch({
      type: 'PREENCHER_TUDO',
      idEdit: -1,
      lotes: [],
      parcelas: [],
      fornecedor: dataFornecedores.data[0],
      numeroNotaFiscal: '',
      data_faturamento: '',
      data_criacao: new Date(),
      loja: {
        nome: 'CARUARU FRIOS',
        value: 'CF',
      },
    });
  }

  const handleCloseDialog = () => {
    setOpen(false);
    resetar();
    setTela(TELA_INICIO_FRENTE_CAIXA);
    handleClose();
  };

  function irParaTelaInit() {
    handleCloseDialog();
  }

  function irParaTelaFinalizarCompra() {
    setTela(TELA_FINALIZAR_FRENTE_CAIXA);
  }

  function irParaTelaFrentedeCaixa() {
    setTela(TELA_INICIO_FRENTE_CAIXA);
  }

  function format10(value) {
    return value < 10 ? `0${value}` : `${value}`;
  }

  function formatDate(date) {
    if (date) {
      const dateReal = new Date(date);
      const ano = dateReal.getFullYear();
      const mes = format10(dateReal.getMonth() + 1);
      const dia = format10(dateReal.getDate());
      return `${ano}-${mes}-${dia}`;
    }
    return '';
  }

  async function getDataCompra(idCompra) {
    try {
      const data = await getListAPI(
        'compras',
        ['id', 'asc'],
        [1, 1],
        { id: [idCompra] },
        [
          'lotes.produto.unidade',
          'parcelas.despesa.conta',
          'fornecedor.cidade.estado',
          'fornecedor.prazosFornecedores',
          'parcelas.despesa.fatura.cartao',
          'parcelas.despesa.problema',
        ],
      );
      if (data.data.length <= 0) {
        throw 'Esta compra não existe!';
      }
      dispatch({
        type: 'PREENCHER_TUDO',
        idEdit: data.data[0].id,
        lotes: formatLotes(data.data[0].lotes),
        parcelas: formatParcelasCompra(data.data[0].parcelas),
        fornecedor: data.data[0].fornecedor,
        numeroNotaFiscal: data.data[0].numero_nota_fiscal
          ? data.data[0].numero_nota_fiscal
          : '',
        data_faturamento: formatDate(data.data[0].data_faturamento), // AJEITAR AQ
        data_criacao: new Date(data.data[0].data),
        loja:
          data.data[0].loja === 'CF'
            ? {
                nome: 'CARUARU FRIOS',
                value: 'CF',
              }
            : {
                nome: 'CASA DA PIZZA',
                value: 'CP',
              },
      });
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      irParaTelaInit();
    }
  }

  useImperativeHandle(ref, () => ({
    handleCreate() {
      reiniciar();
      setOpen(true);
    },
    handleEdit(idCompra) {
      getDataCompra(idCompra);
      setOpen(true);
    },
  }));

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Dialog
          open={open}
          aria-labelledby="form-dialog-title"
          fullScreen
          /* scroll="body" */
        >
          {/* <DialogTitle
            id="form-dialog-title"
          >
            {`Nova Compra - ${tela === TELA_INICIO_FRENTE_CAIXA ? 'LOTES' : 'PARCELAS'}`}
          </DialogTitle> */}
          <DialogContent
            style={{
              padding: '0',
              margin: '0',
              // height: 'calc(100vh)',
              // backgroundColor: '#f5f5f5',
              /* background: 'url(https://source.unsplash.com/collection/2288687/1600x900)',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover', */
              backgroundColor: '#ede8e8',
              backgroundImage: `url(${imagem})`,
              backgroundSize: 'cover',
            }}
            dividers
          >
            <CompraContext.Provider
              value={{ compra, dispatch, openMenu: () => {} }}
            >
              {tela === TELA_INICIO_FRENTE_CAIXA ? (
                <InicioFrenteCaixaCompra
                  irParaTelaInit={irParaTelaInit}
                  irParaTelaFinalizarCompra={irParaTelaFinalizarCompra}
                  showAtendente={false}
                />
              ) : (
                <FinalizarFrenteCaixaCompra
                  irParaTelaInit={irParaTelaInit}
                  irParaTelaFrentedeCaixa={irParaTelaFrentedeCaixa}
                  showAtendente={false}
                  editarModo={compra.idEdit > 0}
                />
              )}
            </CompraContext.Provider>
          </DialogContent>
        </Dialog>
      </ThemeProvider>
    </div>
  );
});

export default DialogoCreateCompra;
